/* eslint-disable */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

//Icons
import DeviceThermostatIcon from '@mui/icons-material/DeviceThermostat';
import WbSunnyIcon from '@mui/icons-material/WbSunny';

// Data
import reportsBarChartData from "layouts/dashboard/data/reportsBarChartData";
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";

// Dashboard components
import Projects from "layouts/dashboard/components/Projects";
import Departments from "layouts/dashboard/components/Departments";
import OrdersOverview from "layouts/dashboard/components/OrdersOverview";

function Dashboard() {
  const {sales, tasks} = reportsLineChartData;

  const [userCount, setUserCount] = useState(["userCount"]);
  const [temperature, setTemperature] = useState(["Temp"]);
  const [temperatureMin, setTemperatureMin] = useState(["Min"]);
  const [temperatureMax, setTemperatureMax] = useState(["Max"]);
  const [temperatureFeelsMin, setTemperatureFeelsMin] = useState(["feelsMin"]);
  const [temperatureFeelsMax, setTemperatureFeelsMax] = useState(["feelsMax"]);
  
  const fetchWeatherDataFromServer = async () => {
    try {
      const response = await fetch("https://weather.visualcrossing.com/VisualCrossingWebServices/rest/services/timeline/Bydgoszcz?unitGroup=metric&key=49JMRPVT8U8PKC8SH62PEHSHZ&contentType=json");
      const data = await response.json();
      
      // Sprawdź, czy istnieją dni w odpowiedzi
      if (data && data.days && data.days.length > 0) {
      // Pobierz temperaturę dla pierwszego dnia
      const todayTemperature = data.days[0].temp;
      setTemperature(todayTemperature);
      setTemperatureMin(data.days[0].tempmin);
      setTemperatureMax(data.days[0].tempmax);
      setTemperatureFeelsMin(data.days[0].feelslikemin);
      setTemperatureFeelsMax(data.days[0].feelslikemax);
      
      // Zwróć temperaturę
      console.log("todayTemperature: " + todayTemperature);
      console.log("temperatureMin: " + temperatureMin);
      console.log("temperatureMax: " + temperatureMax);
      console.log("temperatureFeelsMin: " + temperatureFeelsMin);
      console.log("temperatureFeelsMax: " + temperatureFeelsMax);
      // return todayTemperature;
      } else {
        console.error("Nieprawidłowa odpowiedź z serwera.");
        // return null;
      }
    } catch (error) {
      console.error("Błąd podczas pobierania danych z serwera:", error);
      return [];
    }
  };

  const fetchUserCount = async () => {
    try {
      const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/fetch-users-count.php");
      const data = await response.json();
      setUserCount(data);
    } catch (error) {
      console.error("Błąd podczas pobierania danych z serwera:", error);
      return [];
    }
  };

  useEffect(() => {
    fetchWeatherDataFromServer(); // Wywołaj funkcję pobierającą dane z serwera po zamontowaniu komponentu
    fetchUserCount();
  }, []); // Pusta tablica zależności oznacza, że useEffect zostanie uruchomiony tylko raz po zamontowaniu komponentu
  
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3} style={{ paddingTop: "25px" }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard color="success" icon="person_add" title="Użytkowników" count={`👨‍💼 ${userCount}`} percentage={{color: "success", amount: "", /*label: "Just updated",*/ }} />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard icon={<WbSunnyIcon />} title="Pogoda w Bydgoszczy (Średnio)" count={`${temperature}°C`} 
                percentage={{color: "success", 
                  amount: `⌚${new Date().getHours()}:${new Date().getMinutes()}`, 
                  label: `Min:${temperatureMin}°C, Max:${temperatureMax}°C, Feel Min: ${temperatureFeelsMin}, Max: ${temperatureFeelsMax}`, }} 
              />
            </MDBox>
          </Grid>
          {/* <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard color="success" icon="store" title="Revenue" count="34k" percentage={{color: "success", amount: "+1%", label: "than yesterday", }} />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard color="dark" icon="weekend" title="Bookings" count={281} percentage={{color: "success", amount: "+55%", label: "than lask week", }} />
            </MDBox>
          </Grid> */}
        </Grid>
        {/* <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsBarChart
                  color="info"
                  title="website views"
                  description="Last Campaign Performance"
                  date="campaign sent 2 days ago"
                  chart={reportsBarChartData}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="success"
                  title="daily sales"
                  description={
                    <>
                      (<strong>+15%</strong>) increase in today sales.
                    </>
                  }
                  date="updated 4 min ago"
                  chart={sales}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="dark"
                  title="completed tasks"
                  description="Last Campaign Performance"
                  date="just updated"
                  chart={tasks}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox> */}
        <MDBox py={3}>
          <Grid container spacing={3}>
            {/* <Grid item xs={12} md={6} lg={8}>
              <Projects />
            </Grid> */}
            <Grid item xs={12} md={6} lg={8}>
              <Departments />
            </Grid>
            {/* <Grid item xs={12} md={6} lg={4}>
              <OrdersOverview />
            </Grid> */}
          </Grid>
        </MDBox>
      </MDBox>
      <Footer company={{href: "https://devcolibri.pl/", name: "DevColibri",}} />
    </DashboardLayout>
  );
}

export default Dashboard;
